enum ErrorLocaleKey {
  CALENDAR_TIMEOUT = 'error.calendar.timeout',
  NO_ROOMS_FOUND = 'error.rooms.zero-rooms',
  FLIGHT_EXPIRED = 'error.flight.flight-expired',
}

// Subset of backend app/Exceptions/ErrorTag.php
enum ErrorTag {
  NO_RESULT = 'No result',
}

enum ErrorTypes {
  PACKAGE_SEARCH_ABORTED = 'SearchAbortedError',
  STATE_ABORTED = 'StateAbortedError',
  STATE_EXPIRED = 'StateExpiredError',
  STATE_EXPIRED_MESSAGE = 'state_expired',
  SQL_TIMEOUT_MESSAGE = 'internal_sql_timeout',
  WAITINGLIST = 'WaitinglistError',
  INVALID_TRIP = 'InvalidTripError',
  INVALID_PARAMS = 'InvalidParamsError',
  CONNECTION_ABORTED = 'ECONNABORTED',
  NO_RESPONSE = '<no response>',
  TIMEOUT_ABORT = 'TimeoutError',
  TIMEOUT_ABORT_MESSAGE = 'due to timeout',
}

/**
 * A page's awaited useAsyncData resolved with neither data nor error: the browser cancelled the request (the visitor
 * left mid-load) or a prerendered page hydrated without its payload. Not a bug and not re-fetched by design (Nuxt 4
 * inlines the payload); the message is in IGNORE_ERRORS.
 */
const MISSING_PAGE_DATA_MESSAGE = 'Missing page data'

export {
  ErrorLocaleKey,
  ErrorTag,
  ErrorTypes,
  MISSING_PAGE_DATA_MESSAGE,
}
